<script setup>
import { ref } from 'vue'

const props = defineProps({
    categoriasLotes: Object,
})

const isOpenSubastas = ref(true)
const isOpenCategorias = ref(false)

const baseUrl = process.env.VUE_APP_SISTEMA_SUBASTAS_ACTUAL_URL

function toggleSubastas() {
    isOpenSubastas.value = !isOpenSubastas.value
}

function toggleCategorias() {
    isOpenCategorias.value = !isOpenCategorias.value
}
</script>

<template>
    <div class="menuDesplegable">
        <ul class="list-unstyled">
            <!-- Subastas -->
            <li class="text-start d-flex justify-content-between align-items-center" @click="toggleSubastas"
                style="cursor: pointer;">
                <a href="#" class="fw-bold d-block py-2 text-decoration-none"
                    :class="isOpenSubastas ? 'text-primary' : 'text'">
                    Subastas
                </a>
                <i :class="isOpenSubastas ? 'fa fa-angle-up' : 'fa fa-angle-down'" class="fs-5 text-dark"></i>
            </li>
            <hr class="dropdown-divider text-muted">

            <ul v-if="isOpenSubastas" class="list-unstyled ps-3">
                <li><a :href="`${baseUrl}`" class="d-block fw-bold py-2">Subastas en vivo</a></li>
                <li><a href="/" class="d-block fw-bold py-2">Subastas cronometradas</a></li>
                <li><a href="/usuario" class="d-block fw-bold py-2">Mi cuenta</a></li>
                <li><a href="/como-participar" class="d-block fw-bold py-2">Cómo Participar</a></li>
                <li><a :href="`${baseUrl}/es/comercio-exterior`" class="d-block fw-bold py-2">Proyectos e
                        inversiones</a></li>
                <li><a :href="`${baseUrl}/medios`" class="d-block fw-bold py-2">Medios</a></li>
                <li><a :href="`${baseUrl}/blog`" class="d-block fw-bold py-2">Novedades</a></li>
                <li><a :href="`${baseUrl}/institucional`" class="d-block fw-bold py-2">Quiénes Somos</a></li>
                <li><a :href="`${baseUrl}/subastas/preguntas-frecuentes`" class="d-block fw-bold py-2">Preguntas
                        frecuentes</a></li>
                <li><a :href="`${baseUrl}/terminos`" class="d-block fw-bold py-2">Términos y Condiciones</a></li>
            </ul>

            <!-- Categorias -->
            <li class="text-start d-flex justify-content-between align-items-center" @click="toggleCategorias"
                style="cursor: pointer;">
                <a href="#" class="fw-bold d-block py-2 text-decoration-none"
                    :class="isOpenCategorias ? 'text-primary' : 'text'">
                    Categorías
                </a>
                <i :class="isOpenCategorias ? 'fa fa-angle-up' : 'fa fa-angle-down'" class="fs-5 text-dark"></i>
            </li>
            <hr class="dropdown-divider">

            <ul v-if="isOpenCategorias" class="list-unstyled ps-3">
                <li v-for="cat in props.categoriasLotes" :key="cat.id">
                    <router-link :to="{ name: 'Subasta - Listado de lotes - en categoria', params: { id: cat.id } }"
                        class="d-block fw-bold py-2">
                        {{ cat.nombre }}
                    </router-link>
                </li>
                <li v-if="!props.categoriasLotes?.length" class="d-block px-3 py-2 text-muted small">(Sin
                    categorías aún)</li>
            </ul>

            <!-- Gestión Inmobiliaria -->
            <li class="text-start d-flex justify-content-between align-items-center" style="cursor: pointer;">
                <a href="https://adrianmercadorealestate.com/" class="fw-bold d-block py-2 text-decoration-none">
                    Gestión Inmobiliaria
                </a>
            </li>
        </ul>
    </div>
</template>


<style scoped>
.menuDesplegable {
    position: fixed;
    top: 63px;
    left: 0;
    width: 100vw;
    /* 100% del ancho de la pantalla */
    background-color: #fff;
    z-index: 1050;
    /* Asegurate que esté por encima del navbar */
    padding: 1rem;
    overflow-y: auto;
}
</style>